import { DropDownInfo } from "../../services/interface/IHome";
import rightarrow from "../../assets/rightarrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { transformTitle } from "../../utils/formatter";
import { useDispatch } from "react-redux";
import { setSelectedGbpFilter, setSelectionFlag } from "../../services/redux/reducer/filter.reducer";
import { setApplyFilter, setClearState } from "../../services/redux/reducer/demandfilter.reducer";

type props = { dropdown: DropDownInfo };

const DropDown = ({ dropdown }: props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
const navigateToHandler = (value: string | null) => {
        if (value === "Kpi") {
         value = "/PerformanceMetrics";
        }
    if (!value) return;
    if (value === "CategoryLevelSeasonalTrend") {
        // Open in new tab
        const newTabUrl = `https://demandbrain-dev-pe-b9hgecgtdncrbda9.a01.azurefd.net/forecast/Category-trends?demandbrain=true`;
        window.open(newTabUrl, '_blank', 'noopener,noreferrer');
    }
   else if (value === "/inventory/inventory-alerts?alert=HighStockout") {
        // Open in new tab
        const newTabUrl = `https://demandbrain-dev-pe-b9hgecgtdncrbda9.a01.azurefd.net/inventory/inventory-alerts/stockout-inventory-managment?type=0&demandbrain=true`;
        window.open(newTabUrl, '_blank', 'noopener,noreferrer');
    } else {
        // Navigate in same tab
        navigate(value);
        dispatch(setSelectionFlag(false));
        dispatch(setSelectedGbpFilter({}));
        dispatch(setApplyFilter(""));
        dispatch(setClearState());
    }
};

    const { alertKey } = dropdown;

    return <ul className="absolute top-[100%] left-0 w-full translate-y-[3px] m-auto z-50">
        {dropdown.options.map((option, index) => {
            if (alertKey === "/inventory/inventory-alerts" || alertKey === "/forecast/forecast-alerts") {
                return <li onClick={() => navigateToHandler(`${alertKey}?alert=${transformTitle(option)}`)} key={index} className="flex items-center p-[7px] border-[1px] bg-white justify-between">
                    <span className="font-normal navbar-menu text-[#000]">{option}</span>
                    <img className="w-[0.5vw]" src={rightarrow} alt="rightarrow" />
                </li>
            }
            else {
                return <li onClick={() => navigateToHandler(`${transformTitle(option)}`)} key={index} className="flex items-center p-[7px] border-[1px] bg-white justify-between">
                    <span className="font-normal navbar-menu text-[#000]">{option}</span>
                    <img className="w-[0.5vw]" src={rightarrow} alt="rightarrow" />
                </li>
            }
        })}
    </ul>
}

export default DropDown;